import { createFileRoute } from "@tanstack/react-router";
import BlogZonderVrijwilligers from "@/pages/BlogZonderVrijwilligers";

export const Route = createFileRoute("/blog/husselavond-zonder-vrijwilligers")({
  head: () => ({
    meta: [
      { title: "Husselavond organiseren zonder vrijwilligers? Zo werkt het | De Hussel App" },
      { name: "description", content: "Geen husselaar beschikbaar? Veel tennisclubs draaien hun husselavond inmiddels zonder vrijwilliger. Zo lossen automatische indelingen het probleem op." },
      { property: "og:title", content: "Husselavond organiseren zonder vrijwilligers? Zo werkt het | De Hussel App" },
      { property: "og:description", content: "Geen husselaar beschikbaar? Veel tennisclubs draaien hun husselavond inmiddels zonder vrijwilliger. Zo lossen automatische indelingen het probleem op." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/blog/husselavond-zonder-vrijwilligers" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/blog/husselavond-zonder-vrijwilligers" }],
  }),
  component: BlogZonderVrijwilligers,
});
